import React from "react";
import { Input, Form } from "antd";

const AdnInput = ({
    name,
    label,
    prefix,
    showCount,
    maxLength,
    minLength,
    type,
    placeholder,
    rules,
    value,
    addonBefore,
    addonAfter,
    readOnly,
    handleChange,
    handleBlur,
    validateTrigger = "onBlur",
    min,
    max,
    disabled,

}) => {
    return (
        <div>
            <Form.Item
                name={name}
                label={label}
                valuePropName={value}
                rules={readOnly ? [] : rules}
                validateTrigger={validateTrigger}
            >
                <Input
                    onChange={handleChange}
                    onBlur={handleBlur}
                    prefix={prefix}
                    type={type}
                    value={value}
                    placeholder={readOnly ? "" : placeholder}
                    showCount={showCount}
                    maxLength={maxLength}
                    minLength={minLength}
                    addonBefore={addonBefore}
                    addonAfter={addonAfter}
                    readOnly={readOnly || false}
                    min={min}
                    max={max}
                    disabled={disabled}
                />
            </Form.Item>
        </div>
    );
};

export default AdnInput;
